import wordsFrequencyJson from "#words-frequency-json" with { type: "json" };

export type WordsFrequencyBucket = {
  /** Lower bound of the bucket's cumulative percentage range. */
  lowerPct: number;
  /** Cumulative top-of-text percentage threshold (e.g. 10, 20, …, 99.9). */
  threshold: number;
  /** Upper bound of the bucket's cumulative percentage range (= threshold). */
  upperPct: number;
  /** Word forms whose cumulative frequency falls inside [lowerPct, upperPct], in rank order. */
  words: string[];
};

export type WordsFrequencyData = {
  /** Buckets in ascending threshold order. */
  buckets: WordsFrequencyBucket[];
  /** Distinct Unicode graphemes in first-seen catalog order, computed at build time. */
  uniqueGraphemes: string[];
};

export const wordsFrequency: WordsFrequencyData = wordsFrequencyJson;
